module.exports = "/fonts/quark-light.eot?9289b988e9aa7daf342c4a92dabe5d4f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-light.eot
// module id = 8+zX
// module chunks = 0